import { Spin } from "antd";
import { TenantPage } from "components/UI/TenantPage/TenantPage";

export const RedirectPage = () => {
    return (
        <TenantPage>
            <div className={"flex items-center justify-center min-h-screen"}>
                <Spin />
            </div>
        </TenantPage>
    );
};
